import MaterialList from '../components/MaterialList/MaterialList';
import Subjects from '../components/Subjects/Subjects';
import AdminLoginPage from '../pages/AdminLoginPage/AdminLoginPage';
import TeacherSelectClass from '../pages/TeacherSelectClass/TeacherSelectClass';
import TeacherStudentClassroom from '../pages/TeacherStudentClassroom/TeacherStudentClassroom';
import { useAppSelector } from '../redux/app/hooks';
import { JITSI, STUDENT_ROLE, TEACHER_ROLE } from '../utils/constants'
import TeacherTeachingMaterial from '../pages/TeacherTeachingMaterial/TeacherTeachingMaterial';
import TeacherExaminationGuide from '../pages/TeacherExaminationGuides/TeacherExaminationGuides';
import LiveClass from '../pages/LiveClass/LiveClass';
import ImageMaterial from '../pages/ImageMaterial/ImageMaterial';
import QuestionBank from '../pages/QuestionBank/QuestionBank';
import PodCast from '../pages/PodCast/PodCast';
import SyndicatedVideos from '../pages/SyndicatedVideos/SyndicatedVideos';
import TestPage from '../components/TestPage/TestPage';
import StudentQuizResults from '../components/StudentQuizResults/StudentQuizResults';
import AdminAnnouncement from '../pages/AdminAnnouncement/AdminAnnouncement';
import TeacherStudentSettings from '../pages/TeacherStudentSettings/TeacherStudentSettings';
import StudentProfile from '../pages/StudentProfile/StudentProfile';
import Help from '../pages/Help/Help';
import TermsAndPrivacyPolicy from '../pages/Help/TermsAndPrivacyPolicy';
import Support from '../pages/Support/Support';
import SchoolProfile from '../pages/SchoolProfile/SchoolProfile';
import Legal from '../pages/Legal/Legal';
import Faq from '../pages/Faq/Faq';
import ChimeMeeting from '../components/ChimeMeeting/ChimeMeeting';
import UnderConstruction from '../components/UnderConstruction/UnderConstruction';
import VirtualClassLandingPage from '../pages/VirtualClassLandingPage/VirtualClassLandingPage';
import { JitsiConference } from '../Jitsi/JitsiConference';
import { JitsiConferenceReactSdk } from '../Jitsi/JitsiConferenceReactSdk';
import { useLocation } from 'react-router-dom';
import { JitsiConferenceCustomUI } from '../Jitsi/JitsiConferenceCustomUI';

export type navigationPropertiesTypes ={
    path: string,
    component: React.FC

}
type navigationType ={
    public : navigationPropertiesTypes[],
    private: navigationPropertiesTypes[],
    meet: navigationPropertiesTypes[]
}


export const useNavigation =()=>{
  const { role, loginpage} = useAppSelector((state) => state.auth);
  const isKaton = useAppSelector((state) => state.auth.isKaton);
  const { meetService, meetServiceOrganization } = useAppSelector((state) => state.auth)  
  const schoolType = useAppSelector((state) => state.auth.schoolType);
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const isKatonParam = params.get('isKaton');

  console.log({ location });
  
  const navigation: navigationType = {
    public: [
        {
            path: "/",
            component: VirtualClassLandingPage
        },
        {
            path: '/virtual-school/virtual-teacher-login',
            component: AdminLoginPage
        },
        {
          path: '/virtual-school/virtual-student-signup',
          component: AdminLoginPage
        },
        {
          path: '/virtual-school/virtual-student-login',
          component: AdminLoginPage
        },
        {
          path: '/virtual-school/virtual-student-forgot-password',
          component: AdminLoginPage
        },
        {
          path: '/virtual-school/teacher-select-class',
          component: TeacherSelectClass
        },
        {
          path: "/faq",
          component: Faq,
        },
        {
          path: "/legal",
          component: Legal,
        },
        {
          path: "/support",
          component: Support,
        },
      ],
      private: 
        (role === STUDENT_ROLE) ? [
            {
                path: '/student-classroom',
                component: TeacherStudentClassroom
            },
            {
                path: '/school-profile',
                component: SchoolProfile
            },
            {
                path: '/student-classroom/liveclass',
                component: LiveClass
            },
            {
                path: '/student-classroom/ebooks',
                component: Subjects
            },
            {
                path: '/student-classroom/images',
                component: Subjects
            },
            {
                path: '/student-classroom/images/materials',
                component: ImageMaterial
            },
            {
                path: '/student-classroom/videos',
                component: Subjects
            },
            {
                path: '/student-classroom/podcast',
                component: Subjects
            },
            {
                path: '/student-classroom/podcast/materials',
                component: PodCast
            },
            {
                path: '/student-classroom/videos/materials',
                component: SyndicatedVideos
            },
            {
                path: '/student-announcement',
                component: AdminAnnouncement
            },
            {
                path: '/student-classroom/ebooks/materials',
                component: MaterialList
            },
            {
                path: '/student-classroom/ebooks/materials/learning-materials',
                component: TeacherTeachingMaterial
            },
            {
                path: '/student-classroom/ebooks/materials/question-bank',
                component: QuestionBank
            },
            {
                path: '/student-classroom/question-bank/test',
                component: TestPage
            },
            {
                path: '/student-classroom/question-bank/view',
                component: StudentQuizResults
            },
            {
                path: '/student-classroom/ebooks/materials/examination-guide',
                component: TeacherExaminationGuide
            },
            {
                path: '/student-classroom/images/materials',
                component: ImageMaterial
            },
            {
                path: "/student-settings",
                component: TeacherStudentSettings,
            },
            {
                path: "/student-settings/profile",
                component: StudentProfile,
            }
        ] : (role === TEACHER_ROLE) ? [
            {
                path: '/teacher-classroom',
                component: TeacherStudentClassroom
            },
            {
                path: '/school-profile',
                component: SchoolProfile
            },
            {
                path: '/teacher-classroom/liveclass',
                component: LiveClass
            },
            {
                path: '/teacher-classroom/ebooks',
                component: Subjects
            },
            {
                path: '/teacher-classroom/images',
                component: Subjects
            },
            {
                path: '/teacher-classroom/images/materials',
                component: ImageMaterial
            },
            {
                path: '/teacher-classroom/videos',
                component: Subjects
            },
            {
                path: '/teacher-classroom/podcast',
                component: Subjects
            },
            {
                path: '/teacher-classroom/podcast/materials',
                component: PodCast
            },
            {
                path: '/teacher-classroom/videos/materials',
                component: SyndicatedVideos
            },
            {
                path: '/teacher-announcement',
                component: AdminAnnouncement
            },
            {
                path: '/teacher-classroom/ebooks/materials',
                component: MaterialList
            },
            {
                path: '/teacher-classroom/ebooks/materials/teaching-materials',
                component: TeacherTeachingMaterial
            },
            {
                path: '/teacher-classroom/ebooks/materials/question-bank',
                component: QuestionBank
            },
            {
                path: '/teacher-classroom/ebooks/materials/examination-guide',
                component: TeacherExaminationGuide
            },
            {
                path: "/teacher-settings",
                component: TeacherStudentSettings,
            },
            {
                path: "/teacher-settings/profile",
                component: StudentProfile,
            }
        ] : [],
        meet: role === TEACHER_ROLE ? 
        [    
            {
                path: '/teacher-classroom/liveclass/meeting',
                component: meetService === JITSI ? JitsiConferenceCustomUI : ChimeMeeting
            }
        ] :
        role === STUDENT_ROLE ? 
        [
            {
                path: '/student-classroom/liveclass/meeting',
                component: meetService === JITSI ? JitsiConferenceCustomUI : ChimeMeeting
            }
        ]
        :
        []
    } 
    return {navigation}
}
